var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_42024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.66699H8.33332C7.41285 6.66699 6.66666 7.41318 6.66666 8.33366V16.667C6.66666 17.5875 7.41285 18.3337 8.33332 18.3337H16.6667C17.5871 18.3337 18.3333 17.5875 18.3333 16.667V8.33366C18.3333 7.41318 17.5871 6.66699 16.6667 6.66699Z",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 13.3337C2.41666 13.3337 1.66666 12.5837 1.66666 11.667V3.33366C1.66666 2.41699 2.41666 1.66699 3.33332 1.66699H11.6667C12.5833 1.66699 13.3333 2.41699 13.3333 3.33366",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_42024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.dca0b0a8a640d5fe5083dcbe494f7451.svg";
export { ForwardRef as ReactComponent };